"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocation = exports.seoLocationWatcher = exports.isFromSeoStr = exports.isFromSeoKey = exports.urlForMContJd = exports.checkIsSeoPage = exports.getGlobalWindow = void 0;
var getUrlParam_1 = require("../tools/getUrlParam");
var searchParam_1 = require("../tools/searchParam");
var getRelSeoUrl_1 = require("./getRelSeoUrl");
var getGlobalWindow_1 = require("../tools/getGlobalWindow");
exports.getGlobalWindow = getGlobalWindow_1.getWindow;
function checkIsSeoPage(origin1) {
    var wd = (0, exports.getGlobalWindow)();
    try {
        var origin_1 = origin1 || "";
        if (!origin1) {
            origin_1 = wd.location.origin;
        }
        return {
            isJdh: origin_1.includes("jdh.com") ||
                origin_1.includes("nethp-seo.jd.local") ||
                origin_1.includes("nethp-seo.healthjd.com"),
            isContJd: origin_1.includes("cont.jd"),
        };
    }
    catch (e) {
        // console.log(e);
        return {};
    }
}
exports.checkIsSeoPage = checkIsSeoPage;
function urlForMContJd(url, isPhone) {
    if (isPhone === void 0) { isPhone = true; }
    if (!isPhone) {
        return url;
    }
    var isSeoPage = checkIsSeoPage(!url ||
        url.startsWith("http://") ||
        url.startsWith("https://") ||
        url.startsWith("//")
        ? url
        : undefined);
    if (!isSeoPage.isContJd) {
        return url;
    }
    var list = [
        "hospital",
        "dianping",
        "qalist",
        "qa",
        "doctor",
        "department",
        "qalist_dp",
        "articlelist_dp",
    ];
    var rStr = list.find(function (item) { return url.includes("/".concat(item, "/")); });
    if (rStr) {
        url = url.replace("/".concat(rStr, "/"), "/m".concat(rStr, "/"));
    }
    return url;
}
exports.urlForMContJd = urlForMContJd;
exports.isFromSeoKey = "isFromSeo";
exports.isFromSeoStr = "".concat(exports.isFromSeoKey, "=true");
function seoLocationWatcher(isNode, appInfo, useServeCtro) {
    var _this = this;
    if (isNode === void 0) { isNode = false; }
    if (appInfo === void 0) { appInfo = {}; }
    if (useServeCtro === void 0) { useServeCtro = false; }
    var wd = (0, exports.getGlobalWindow)();
    var isSeoPage = checkIsSeoPage();
    // 跳转的地址与seo页面的映射
    var seoUrlMap = function (aimUrl) {
        if (aimUrl === void 0) { aimUrl = ""; }
        return __awaiter(_this, void 0, void 0, function () {
            var _a, origin, search, isSeo, params, presurlPath, bb, realUrl, bb1, paramsStr, lurl, url, diseasesId, url, url, st1, diagId, url, st1, doctorId, url, url, departmentId, url, departmentId, url;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = wd.location, origin = _a.origin, search = _a.search;
                        isSeo = false;
                        if (!useServeCtro) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, getRelSeoUrl_1.checkIsSeo)(realLocation.href)];
                    case 1:
                        isSeo = _b.sent(); // 后端判断是否是seo
                        return [3 /*break*/, 3];
                    case 2:
                        isSeo = isSeoPage.isJdh || isSeoPage.isContJd || false;
                        _b.label = 3;
                    case 3:
                        params = (0, getUrlParam_1.getUrlParam)(aimUrl);
                        presurlPath = aimUrl.split("?")[0] || "";
                        if (isSeo || search.includes(exports.isFromSeoStr)) {
                            params[exports.isFromSeoKey] = true;
                            bb = (0, searchParam_1.searchParam)(params);
                            aimUrl = "".concat(presurlPath).concat(bb ? "?".concat(bb) : "");
                        }
                        if (!isSeo) {
                            return [2 /*return*/, aimUrl];
                        }
                        if (!useServeCtro) return [3 /*break*/, 5];
                        return [4 /*yield*/, (0, getRelSeoUrl_1.getRelSeoUrl)(aimUrl)];
                    case 4:
                        realUrl = _b.sent();
                        return [2 /*return*/, realUrl || aimUrl];
                    case 5:
                        bb1 = (0, searchParam_1.searchParam)(params);
                        paramsStr = "".concat(bb1 ? "?".concat(bb1) : "");
                        lurl = aimUrl.toLocaleLowerCase();
                        if (lurl.startsWith("openapp")) {
                            return [2 /*return*/, aimUrl];
                        }
                        if (presurlPath.includes("//m.healthjd.com/s/hospital/detail")) {
                            url = "".concat(origin, "/hospital/").concat(params.hospitalId).concat(paramsStr);
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("//m.healthjd.com/s/EvaluationManage/EvaluationList")) {
                            diseasesId = params.diseasesId || params.diseases;
                            url = "".concat(origin, "/dianping/").concat(params.doctorId).concat(paramsStr);
                            if (diseasesId) {
                                url = "".concat(origin, "/dianping/").concat(params.doctorId, "_").concat(diseasesId).concat(paramsStr);
                            }
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("//m.healthjd.com/s/DesenInquiryList")) {
                            url = "".concat(origin, "/qalist/").concat(params.doctorId).concat(paramsStr);
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("//m.healthjd.com/qa/")) {
                            st1 = presurlPath.split("//m.healthjd.com/qa");
                            diagId = st1[1].split("/")[1];
                            url = "".concat(origin, "/qa/").concat(diagId).concat(paramsStr);
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("//m.healthjd.com/doctor/")) {
                            st1 = presurlPath.split("//m.healthjd.com/doctor");
                            doctorId = st1[1].split("/")[1];
                            url = "".concat(origin, "/doctor/").concat(doctorId).concat(paramsStr);
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("/department/")) {
                            url = presurlPath;
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("/doctor_yellow/doctorHome/inquiry-record")) {
                            departmentId = params.departmentId;
                            url = "".concat(origin, "/qalist_dp/").concat(departmentId).concat(paramsStr);
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        if (presurlPath.includes("/doctor_yellow/doctorHome/article")) {
                            departmentId = params.departmentId;
                            url = "".concat(origin, "/articlelist_dp/").concat(departmentId).concat(paramsStr);
                            url = urlForMContJd(url);
                            return [2 /*return*/, url];
                        }
                        return [2 /*return*/, aimUrl];
                }
            });
        });
    };
    // 对location跳转进行拦截，用于href实现应用内部跳转
    var realLocation = wd.location;
    var seolocation = Object.keys(realLocation).reduce(function (v, k) {
        var val = realLocation[k];
        if (typeof val === "function") {
            v[k] = val.bind(realLocation);
        }
        else if (typeof val === "string") {
            v[k] = val;
        }
        else {
            v[k] = val;
        }
        return v;
    }, {});
    seolocation.__proto__ = realLocation.__proto__;
    var history = appInfo.history;
    var appBaseName = appInfo.appBaseName;
    var currentApp = history ? "".concat(origin).concat(appBaseName) : "";
    var goHref = function (value, replace) {
        if (value === void 0) { value = ""; }
        if (replace === void 0) { replace = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var aimUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value === realLocation.href) {
                            return [2 /*return*/];
                        }
                        aimUrl = value;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, seoUrlMap(value)];
                    case 2:
                        aimUrl = (_a.sent()) || value;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(111, "aimUrl error", e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        console.log(111, "aimUrl", value, aimUrl);
                        if (replace) {
                            realLocation.replace(aimUrl);
                            return [2 /*return*/];
                        }
                        realLocation.href = aimUrl;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(seolocation, "href", {
        set: function (value) {
            if (!value) {
                return;
            }
            goHref(value);
        },
        get: function () {
            return realLocation.href;
        },
    });
    seolocation.replace = function (value) {
        goHref(value, true);
    };
    // @ts-ignore
    wd.seolocation = seolocation;
    if (isNode) {
        // @ts-ignore
        global.seolocation = seolocation;
    }
}
exports.seoLocationWatcher = seoLocationWatcher;
function getLocation(isNode, appInfo, useServeCtro) {
    if (isNode === void 0) { isNode = false; }
    if (appInfo === void 0) { appInfo = {}; }
    if (useServeCtro === void 0) { useServeCtro = false; }
    var wd = (0, exports.getGlobalWindow)();
    var isSeoPage = checkIsSeoPage();
    var search = wd.location.search;
    var isSeo = isSeoPage.isJdh || isSeoPage.isContJd || search.includes(exports.isFromSeoStr);
    // @ts-ignore
    if (isSeo && !wd.seolocation) {
        seoLocationWatcher(isNode, appInfo, useServeCtro);
    }
    // @ts-ignore
    return wd.seolocation || wd.location;
}
exports.getLocation = getLocation;
